import _defineProperty from "@babel/runtime/helpers/defineProperty";
import classNames from 'classnames';
import React from 'react';
import classes from '@nerdwallet/base-styles/classes';
import { Box, Tooltip, Type } from '@nerdwallet/currency';
import style from './disclaimer-ad.module.less';

var DisclaimerAd = function DisclaimerAd(_ref) {
  var _ref$displayFullWidth = _ref.displayFullWidth,
      displayFullWidth = _ref$displayFullWidth === void 0 ? false : _ref$displayFullWidth,
      _ref$justifyContentMo = _ref.justifyContentMobile,
      justifyContentMobile = _ref$justifyContentMo === void 0 ? 'center' : _ref$justifyContentMo,
      _ref$renderAd = _ref.renderAd,
      renderAd = _ref$renderAd === void 0 ? false : _ref$renderAd,
      text = _ref.text,
      tooltipContent = _ref.tooltipContent,
      _ref$tooltipPlacement = _ref.tooltipPlacement,
      tooltipPlacement = _ref$tooltipPlacement === void 0 ? 'bottom' : _ref$tooltipPlacement;
  return /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: {
      mobile: justifyContentMobile,
      desktop: 'flex-start'
    }
  }, renderAd && /*#__PURE__*/React.createElement(Box, {
    className: style.containerText,
    marginRight: "2"
  }, /*#__PURE__*/React.createElement(Type, {
    className: classes('width-100'),
    size: "0"
  }, "AD")), /*#__PURE__*/React.createElement(Box, {
    className: classNames(style.containerText, _defineProperty({}, style.fullWidthText, displayFullWidth))
  }, /*#__PURE__*/React.createElement(Type, {
    className: classes('width-100'),
    size: "0"
  }, text), !!tooltipContent && /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipContent,
    placement: tooltipPlacement
  })));
};

export default DisclaimerAd;